import { render, staticRenderFns } from "./MobileAnnouncement.vue?vue&type=template&id=98aef954&"
import script from "./MobileAnnouncement.vue?vue&type=script&lang=js&"
export * from "./MobileAnnouncement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports